'use client';

function ArticleVideo({
  url, src, width = '100%', height = '100%',
}) {
  return (

    <video
      src={url || src}
      loop
      autoPlay
      muted
      playsInline
      width={width}
      height={height}
      style={{ display: 'block', maxWidth: '100%' }}
    />
  );
}

export default ArticleVideo;
